/**
 * Saves a blob to the user's machine via a transient anchor element. Lives
 * in the library so app code never creates DOM elements directly.
 */
export function downloadFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  // Deferred — revoking synchronously can cancel the save in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
